export const BRAINTREE_CLIENT_TOKEN = "token123";
